import { module as BaseModule } from 'modujs';
import modular from 'modujs';
import * as themeModules from './modules';

import Lenis from '@studio-freight/lenis';

// Función helper para limpiar atributos data-module
function sanitizeModuleAttributes() {
	const elements = document.querySelectorAll('[data-module]');
	let cleaned = 0;

	elements.forEach(el => {
		const moduleName = el.getAttribute('data-module');

		// Si está vacío o solo tiene espacios
		if (!moduleName || moduleName.trim() === '') {
			console.warn('⚠️ Removiendo data-module vacío de:', el);
			el.removeAttribute('data-module');
			cleaned++;
		}
		// Si tiene espacios extras, limpiarlos
		else if (moduleName !== moduleName.trim()) {
			const cleanName = moduleName.trim();
			el.setAttribute('data-module', cleanName);
			cleaned++;
		}
	});

	return cleaned;
}

// Limpiar antes de inicializar
sanitizeModuleAttributes();

// Inicializar con manejo de errores
try {
	window.themeApp = new modular({
		modules: themeModules
	});

	window.themeApp.init(window.themeApp.modules);


} catch (error) {
}


// Inicialización mínima de Lenis
const lenis = new Lenis({
	duration: 1,
	easing: (t) => 1 - Math.pow(1 - t, 3),
	direction: 'vertical',
	smooth: true,
	smoothTouch: true,
	touchMultiplier: 2
});
window.lenis = lenis;



// Observador de clase en body para pausar/reanudar Lenis (mantener si usas .no-scroll)
const bodyObserver = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
			const hasNoScroll = document.body.classList.contains('no-scroll');
			if (hasNoScroll) {
				lenis.stop();
			} else {
				lenis.start();
			}
		}
	});
});
bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });


/* const navObserver = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		console.log(mutation);
		if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
			const hasNavOpen = nav.classList.contains('open');
			console.log(hasNavOpen);
			if (hasNavOpen) {
				lenis.stop();
			} else {
				lenis.start();
			}
		}
	});
});
navObserver.observe(document.querySelector('.theme-nav'), { attributes: true, attributeFilter: ['class'] }); */

// Maneja la clase del header según el estado de scroll
function handleHeaderScroll(lenis) {
	const headerElement = document.querySelector('header');
	if (!headerElement) return;
	const isHomepage = document.body.classList.contains('home');
	const nav = document.querySelector('.theme-nav');
	let navIsOpen = nav?.classList.contains('open');
	if (!isHomepage && !navIsOpen) {
		lenis.on('scroll', (e) => {
			headerElement.classList.toggle('up', !!e.__isScrolling);
		});
	}
}

// Manejo de enlaces ancla para scroll suave
function handleAnchorLinks(lenis) {
	window.addEventListener('hashchange', () => {
		if (window.location.hash) {
			smoothScrollToAnchor(window.location.hash, lenis);
		}
	});
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', (event) => {
			event.preventDefault();
			const targetId = anchor.getAttribute('href');
			smoothScrollToAnchor(targetId, lenis);
		});
	});
}

function initScroll(lenis) {
	handleHeaderScroll(lenis);
	handleAnchorLinks(lenis);
}

// RAF loop para Lenis y lazySizes si está presente
function raf(time) {
	lenis.raf(time);
	if (window.lazySizes && window.lazySizes.loader) {
		window.lazySizes.loader.checkElems();
	}
	requestAnimationFrame(raf);
}

// Observa cambios de tamaño del body para redimensionar Lenis
function observeBodySize(lenis) {
	const bodyElement = document.querySelector('body');
	if (!bodyElement) return;
	const resizeObserver = new ResizeObserver((entries) => {
		for (let entry of entries) {
			if (entry.target === bodyElement) {
				lenis.resize();
			}
		}
	});
	resizeObserver.observe(bodyElement);
}

// Scroll suave hacia un anchor (usa Lenis)
function smoothScrollToAnchor(anchor, lenis) {
	if (!anchor) return;
	const targetElement = document.querySelector(anchor);
	if (targetElement) {
		const headerHeight = document.querySelector('header')?.offsetHeight || 0;
		const scrollY = window.scrollY || window.pageYOffset || 0;
		const targetPosition = targetElement.getBoundingClientRect().top + scrollY;
		lenis.scrollTo(targetPosition - headerHeight, {
			duration: 2.5,
			easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
		});
	}
}

function initOnLoad() {
	initScroll(lenis);
	observeBodySize(lenis);
	requestAnimationFrame(raf);
}

// Inicialización al cargar DOM
document.addEventListener('DOMContentLoaded', function () {
	if (window.location.hash) {
		const targetId = window.location.hash.substring(1);
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			// Temporalmente quitar hash y hacer scroll suave con retardo
			window.history.replaceState(null, null, ' ');
			setTimeout(() => {
				smoothScrollToAnchor(`#${targetId}`, lenis);
				window.history.replaceState(null, null, `#${targetId}`);
			}, 2000);
		}
	}
	initOnLoad();
});
